import EvolutionTauxMobilite from "./indicators/EvolutionTauxMobilite";
import VoiesPrioritairesPietons from "./indicators/VoiesPrioritairesPietons";
import InfrastructuresCyclablesAvenues from "./indicators/InfrastructuresCyclablesAvenues";
import LongueurVoiesRapides from "./indicators/LongueurVoiesRapides";
import LongueurVoiesTransportPublic from "./indicators/LongueurVoiesTransportPublic";
import DureeMoyenneTrajet from "./indicators/DureeMoyenneTrajet";
import EvolutionTauxMotorisation from "./indicators/EvolutionTauxMotorisation";
import EvolutionPartModaleDeplacementsQuotidiens from "./indicators/EvolutionPartModaleDeplacementsQuotidiens";
import VolumeDeplacementsJournaliersMode from "./indicators/VolumeDeplacementsJournaliersMode";

const ChallengeOne = {
    idSection: "challengeOne",
    titleSection:
        "SUMP Trajectory Content.challenges.challenge1.challengeTitle",
    objectives: {
        objective1: {
            titleObjective:
                "SUMP Trajectory Content.challenges.challenge1.objectives.objective1",
            indicators: {
                volumeDeplacementsJournaliersMode:
                    VolumeDeplacementsJournaliersMode,
                evolutionPartModaleDeplacementsQuotidiens:
                    EvolutionPartModaleDeplacementsQuotidiens,
                evolutionTauxMotorisation: EvolutionTauxMotorisation,
                evolutionTauxMobilite: EvolutionTauxMobilite,
            },
        },
        objective2: {
            titleObjective:
                "SUMP Trajectory Content.challenges.challenge1.objectives.objective2",
            indicators: {
                voiesPrioritairesPietons: VoiesPrioritairesPietons,
            },
        },
        objective3: {
            titleObjective:
                "SUMP Trajectory Content.challenges.challenge1.objectives.objective3",
            indicators: {
                infrastructuresCyclablesAvenues:
                    InfrastructuresCyclablesAvenues,
            },
        },
        objective4: {
            titleObjective:
                "SUMP Trajectory Content.challenges.challenge1.objectives.objective4",
            indicators: { dureeMoyenneTrajet: DureeMoyenneTrajet },
        },
        objective5: {
            titleObjective:
                "SUMP Trajectory Content.challenges.challenge1.objectives.objective5",
            indicators: {
                longueurVoiesTransportPublic: LongueurVoiesTransportPublic,
            },
        },
        objective6: {
            titleObjective:
                "SUMP Trajectory Content.challenges.challenge1.objectives.objective6",
            indicators: {
                longueurVoiesRapides: LongueurVoiesRapides,
            },
        },
    },
};

export default ChallengeOne;
